import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

import t from './common/localization';
import RemoveDialog from './RemoveSweetAlertDialog';
import SuccessDialog from './SuccessSweetAlertDialog';

const useStyles = makeStyles(theme => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  root: {
    padding: '10px',
    margin: '10px',
    marginLeft: '70px',
  },
}));

const EditCollectionView = ({ content, editPath, endpoint, successDialogShow }) => {
  const classes = useStyles();
  const history = useHistory();

  const [selectedId, setSelectedId] = useState(null);
  const [selectedAnchorEl, setSelectedAnchorEl] = useState(null);
  const [removeDialogShown, setRemoveDialogShown] = useState(false);
  const [updateTimestamp, setUpdateTimestamp] = useState(Date.now());
  const [alertProps, setAlertProps] = useState({error:true, title:"Error"});
  const [successDialogShown, setSuccessDialogShown] = useState(successDialogShow);

  const showErrorDialog = (value, message) => {
    setAlertProps({error:true, title:"Error", message});
    setSuccessDialogShown(value);
  }

  const showSuccessDialog = (value, message) => {
    setAlertProps({success:true, title:"Success", message});
    setSuccessDialogShown(value);
  }

  const closeDialogShown = ()=> {
    setSuccessDialogShown(false);
  }


  const menuShow = (anchorId, itemId) => {
    setSelectedAnchorEl(anchorId);
    setSelectedId(itemId);
  }

  const menuHide = () => {
    setSelectedAnchorEl(null);
  }

  const handleAdd = () => {
    history.push(editPath);
    menuHide();
  }

  const handleEdit = () => {
    history.push(`${editPath}/${selectedId}`);
    menuHide();
  }

  const handleOnEdit = (selectedId) => {
    history.push(`${editPath}/${selectedId}`);
    // menuHide();
  }

  const handleOnRemove = (selectedId) => {
    setSelectedId(selectedId);
    setRemoveDialogShown(true);
    // menuHide();
  }

  const handleRemove = () => {
    setRemoveDialogShown(true);
    menuHide();
  }

  const handleRemoveResult = (value, message) => {
    setRemoveDialogShown(false);
    setUpdateTimestamp(Date.now());
    if(value){
    showSuccessDialog(true,message);
    }else {
    if(message){
        showErrorDialog(true, message);
        }else {

        }
    }
  }

  const handleErrorResult = (value) => {
    showErrorDialog(false);
  }

  const Content = content;

  return (
    <>
    <div className={classes.root}>
      <Content updateTimestamp={updateTimestamp} handleOnEdit = {handleOnEdit} handleOnRemove = {handleOnRemove} onMenuClick={menuShow} />
      <Fab size="medium" color="primary" className={classes.fab} onClick={handleAdd}>
        <AddIcon />
      </Fab>
      <Menu open={!!selectedAnchorEl} anchorEl={selectedAnchorEl} onClose={menuHide}>
        <MenuItem onClick={handleEdit}>{t('sharedEdit')}</MenuItem>
        <MenuItem onClick={handleRemove}>{t('sharedRemove')}</MenuItem>
      </Menu>
      <RemoveDialog open={removeDialogShown} message={"Are you sure want to delete it?"} endpoint={endpoint} itemId={selectedId} onResult={handleRemoveResult} />
      <SuccessDialog open={successDialogShown} alertProps ={alertProps} closeDialogShown = {closeDialogShown} onResult={handleErrorResult} />

      </div>
    </>
  );
}

export default EditCollectionView;
